//Expand answer when click on heading
function accordion() {
  var questionContainer = document.getElementById('question-list');
  var questionHeader = document.querySelectorAll(".question__question");

  for (var i = 0; i < questionHeader.length; i++) {

      questionHeader[i].addEventListener("click", function(e) {
        $(this).siblings('.question__answer').slideToggle();
        $(this).parent().toggleClass('expanded');
      });

  }
}
export default accordion
